import { useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../lib/api';

const API = BACKEND_URL;

/**
 * AnalyticsInjector, reads /api/admin/public-config once at mount and injects:
 *   • GA4 gtag.js (when ga4_measurement_id is set)
 *   • Google Search Console verification meta tag
 *   • Bing Webmaster verification meta tag
 *
 * Never blocks the page; runs after first render. Renders nothing.
 */
export default function AnalyticsInjector() {
  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/api/admin/public-config`).then(({ data }) => {
      if (cancelled) return;
      const { ga4_measurement_id, gsc_verification, bing_verification } = data || {};
      if (ga4_measurement_id && /^G-[A-Z0-9]+$/i.test(ga4_measurement_id)) {
        injectGA4(ga4_measurement_id);
      }
      if (gsc_verification) injectMeta('google-site-verification', gsc_verification);
      if (bing_verification) injectMeta('msvalidate.01', bing_verification);
    }).catch(() => {/* silent, analytics is optional */});
    return () => { cancelled = true; };
  }, []);
  return null;
}

function injectMeta(name, content) {
  if (document.head.querySelector(`meta[name="${name}"][data-managed="admin"]`)) return;
  const el = document.createElement('meta');
  el.setAttribute('name', name);
  el.setAttribute('content', content);
  el.setAttribute('data-managed', 'admin');
  document.head.appendChild(el);
}

function injectGA4(id) {
  if (window.__ga4_loaded) return;
  window.__ga4_loaded = true;
  const s1 = document.createElement('script');
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s1);
  const s2 = document.createElement('script');
  s2.text = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', '${id}', { anonymize_ip: true });`;
  document.head.appendChild(s2);
}
